import React from "react";
import { useAuth } from "@context";
import * as actionTypes from "@redux/actionTypes";
import { useDispatch } from "react-redux";
import DiscordIcon from '@images/loginScreen/discord.png';
import DiscordLoginBtnIcon from '@images/loginScreen/ic_baseline-discord.svg';
import CloseIcon from '@images/loginScreen/close.svg';

const SignInModal = ({ closeSignInModel }) => {
  const dispatch = useDispatch();
  const { login } = useAuth();

  const loginDiscordHandler = () => {
    dispatch({
      type: actionTypes.LOADING_SPINNER,
      payload: true,
    });
    login()
  }

  return (
    <div className="noBotInfo-model sign-modal-main-sections">
      <div className="how_to_start_title">
        <p className="sign-in-title">Log In / Sign-up</p>
        <div onClick={closeSignInModel} style={{ cursor: "pointer" }}>
          <img src={CloseIcon} alt="Close Icon" />
        </div>
      </div>
      <div className="noBot_info">
        <div className="discord-login-icon">
          <img src={DiscordIcon} alt="Discord Icon" />
        </div>
        <div className="sing-in-descripctions">
          <p className="sing-in-paragraph">Welcome to FrodoBots!</p>
          <p>
            Join our Discord for LIVE support during your drives, track your
            progress and hang out with fellow FrodoBots drivers!
          </p>
        </div>
      </div>
      <div className="sign-modal-continue">
        <button className="continue-with-discord-btn" onClick={loginDiscordHandler}>
          <img src={DiscordLoginBtnIcon} alt="Discord Login Button Icon" />
          <p className="continue-with-discord-letter">Continue with Discord</p>
        </button>
      </div>
    </div>
  );
};

export default SignInModal;
